/* eslint-disable import/prefer-default-export */
import productDomain from './products.domain';
import products from './products.entities';
import productTypes from './product-types.entities';
import productDetails from './product-details.entities';
import productFilters from './product-filters.entities';

export const entities = {
    products,
    productTypes,
    productDetails,
    productFilters,
};

export const domain = productDomain;
